import { checkPincode } from 'https://www.nilkamalhomes.com/cdn/shop/t/794/assets/pincode-checker.js';
document.addEventListener("DOMContentLoaded", function () {
  // Swiper initialization function
  function initConfigurators() {
    const configuratorSwipers = document.querySelectorAll(
      ".configurator-swiper"
    );

    configuratorSwipers.forEach(function (swiperElement) {
      const swiper = new Swiper(swiperElement, {
        scrollbar: {
          el: swiperElement.querySelector(".swiper-scrollbar"), // ✅ unique scrollbar
          hide: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 3.5,
        spaceBetween: 30,
        freeMode: false,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 5 },
        },
      });

      // Save swiper instance on element for later use
      swiperElement.swiperInstance = swiper;
    });
  }

  // Function to initialize add-on Swipers
  function initAddOnSwipers() {
    const addOnSwipers = document.querySelectorAll(".modularSwiper");
    addOnSwipers.forEach(function (swiperElement) {
      new Swiper(swiperElement, {
        slidesPerView: 1.4,
        spaceBetween: 10,
        freeMode: true,
        mousewheel: { forceToAxis: true },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
        },
        breakpoints: {
          640: { slidesPerView: 1.7, spaceBetween: 10 },
          768: { slidesPerView: 1.7, spaceBetween: 10 },
          1024: { slidesPerView: 1.7, spaceBetween: 10 },
        },
      });
    });
  }

  // Lightweight in-memory cache for fetched product pages
  const productCache =
    window.__productCache || (window.__productCache = new Map());
  let isSwitchingProduct = false;

  function getCachedProduct(url) {
    return productCache.get(url);
  }

  function cacheProduct(url, doc) {
    try {
      productCache.set(url, doc);
    } catch (e) {}
  }

  function parseHTML(text) {
    return new DOMParser().parseFromString(text, "text/html");
  }

  function applyProductDocument(newDoc, url) {
    let newProductHTML = newDoc.querySelector(".product");
    if (newProductHTML && document.querySelector(".product")) {
      document.querySelector(".product").innerHTML = newProductHTML.innerHTML;
    }

    let newAddOnHTML = newDoc.querySelector(".modular_childcontainer");
    if (newAddOnHTML && document.querySelector(".modular_childcontainer")) {
      document.querySelector(".modular_childcontainer").innerHTML =
        newAddOnHTML.innerHTML;
    }

    try {
      window.history.replaceState({}, "", url);
    } catch (e) {}

    // Re-init UI bits
    initConfigurators();
    initAddOnSwipers();
    bindSwatchClicks();
    bindStyleTabs();
    setTimeout(() => {
      restoreLastStyle();
    }, 100);
    reinitializePincodeChecker();
    initAddonSwiper();
    restoreCapacityExpandedState();
    updateStickyBar(newDoc);
    if (typeof window.initMediaGallerySlider === "function") {
      // re-init PDP gallery slider after AJAX swap
      window.initMediaGallerySlider();
    }

    // Hide loaders and remove active states
    document.querySelectorAll(".loader, .loader-line").forEach((loader) => {
      loader.style.display = "none";
    });
    document
      .querySelectorAll(".active_loader, .active-round-loader")
      .forEach((el) =>
        el.classList.remove("active_loader", "active-round-loader")
      );
  }

  function waitUntilAtLeast(startMs, minMs) {
    const elapsed = Date.now() - startMs;
    const remaining = Math.max(0, minMs - elapsed);
    return new Promise((resolve) => setTimeout(resolve, remaining));
  }

  function prefetchProduct(url) {
    if (!url || getCachedProduct(url)) return;
    try {
      // Delay prefetch to avoid blocking main thread/network
      const run = () => {
        fetch(url, { credentials: "same-origin", cache: "force-cache" })
          .then((r) => (r.ok ? r.text() : Promise.reject()))
          .then((txt) => {
            cacheProduct(url, parseHTML(txt));
          })
          .catch(() => {});
      };
      if ("requestIdleCallback" in window) {
        requestIdleCallback(run, { timeout: 1200 });
      } else {
        setTimeout(run, 150);
      }
    } catch (e) {}
  }

  function setupPrefetchForLinks() {
    const links = document.querySelectorAll(".sofa_style_option[href]");

    // Mouseenter prefetch
    links.forEach((link) => {
      link.removeEventListener("mouseenter", link.__pf_handler || (() => {}));
      const handler = () => prefetchProduct(link.getAttribute("href"));
      link.__pf_handler = handler;
      link.addEventListener("mouseenter", handler, { passive: true });
    });

    // Viewport prefetch via IntersectionObserver
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const href = entry.target.getAttribute("href");
              prefetchProduct(href);
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "200px" }
      );

      links.forEach((link) => {
        try {
          io.observe(link);
        } catch (e) {}
      });
    } else {
      // Fallback: prefetch first few visible links
      links.forEach((link, idx) => {
        if (idx < 6) prefetchProduct(link.getAttribute("href"));
      });
    }
  }

  // Function to reinitialize pincode checker
  function reinitializePincodeChecker() {
    const storedPincode = localStorage.getItem("pincode") || "400025";
    // debugger
    checkPincode()
    // debugger
    console.log("[pincode] reinitializePincodeChecker called");
    // if (typeof $ === "undefined") {
    //   console.warn("[pincode] jQuery not available — skipping reinit");
    //   return;
    // }

    // debugger
    // const storedPincode = localStorage.getItem("pincode") || "400025";
    const $input = $(".nh__pincode__checker__input__initial");
    const $errorWrap = $(".please__enter__pincode__error");
    const $addToCart = $('[data-add-to-cart-text="Add to cart"]');
    const $buyNow = $(".shopify-payment-button__button");

    if ($input.length) {
      // Set initial values and clear error state
      $input.val(storedPincode).removeClass("shake error");
      $("#properties__pinocode").val(storedPincode);

      // Remove previous namespaced handlers to avoid duplicates, then re-bind
      $input
        .off(".reinit")
        .on("input.reinit", function () {
          let val = $(this).val().replace(/\D/g, "");
          if (val.length > 6) val = val.slice(0, 6);
          $(this).val(val).removeClass("error");
          $errorWrap.css("display", "none");

          if (val.length === 6) {
            if (typeof runPicodeApi === "function") {
              runPicodeApi();
            } else if (typeof checkPincode === "function") {
              checkPincode();
            }
          }
        })
        .on("focusout.reinit", function () {
          const val = $(this).val();
          if (val.length > 0 && val.length < 6) {
            $(this).addClass("shake error");
            $(".responseURL").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/0099/2867/1291/files/Frame_1091.svg?v=1725537797"
            );
            $(".errorMessage")
              .addClass("errorMessageRed")
              .text("Please enter valid pincode");
            $errorWrap.css("display", "flex");
            $addToCart.attr("disabled", true);
            $buyNow.attr("disabled", true);
            setTimeout(() => $(this).removeClass("shake"), 500);
          }
        })
        .on("keypress.reinit", function (e) {
          if (e.which === 13) {
            if (typeof checkPincode === "function") checkPincode();
          }
        });
    }

    // Reset error UI and enable buttons before validation
    if ($errorWrap.length) $errorWrap.css("display", "none");
    $addToCart.removeAttr("disabled");
    $buyNow.removeAttr("disabled");

    // Trigger validation
    if (typeof checkPincode === "function") {
      checkPincode();
    }
  }

  // Function to handle AJAX product switching with cache and de-dupe
  function ajaxSwitchProduct(url) {
    if (!url) return;
    if (isSwitchingProduct) return; // prevent double triggers
    isSwitchingProduct = true;
    const t0 = Date.now();

    const cached = getCachedProduct(url);
    if (cached) {
      waitUntilAtLeast(t0, 1000).then(() => {
        applyProductDocument(cached, url);
        isSwitchingProduct = false;
      });
      return;
    }

    fetch(url, { credentials: "same-origin", cache: "force-cache" })
      .then((res) => res.text())
      .then((responseText) => {
        const newDoc = parseHTML(responseText);
        cacheProduct(url, newDoc);
        return waitUntilAtLeast(t0, 2000).then(() =>
          applyProductDocument(newDoc, url)
        );
      })
      .catch((err) => console.error("Product fetch error:", err))
      .finally(() => {
        isSwitchingProduct = false;
      });
  }

  // Function to bind swatch/configurator clicks
  function bindSwatchClicks() {
    document.querySelectorAll(".sofa_style_option").forEach((link) => {
      link.removeEventListener("click", swatchHandler);
      link.addEventListener("click", swatchHandler);
    });

    // Bind capacity expand button clicks
    bindCapacityExpandClicks();

    // Setup prefetch for current links
    setupPrefetchForLinks();
  }

  // Function to bind capacity expand button functionality
  function bindCapacityExpandClicks() {
    const expandBtn = document.querySelector(".capacity-expand-btn");
    if (expandBtn) {
      expandBtn.removeEventListener("click", capacityExpandHandler);
      expandBtn.addEventListener("click", capacityExpandHandler);
    }
  }

  // Function to handle capacity expand/collapse
  function capacityExpandHandler(e) {
    e.preventDefault();
    const expandBtnContainer = document.querySelector(
      ".capacity-expand-btn-container"
    );
    const remainingOptions = document.querySelectorAll(
      ".capacity-remaining-option"
    );
    const expandBtn = this;
    const plusIcon = expandBtn.querySelector(".plus-icon");
    const remainingText = expandBtn.querySelector(".remaining-text");

    if (expandBtnContainer.style.display !== "none") {
      // Expand - hide the + button and show remaining options
      expandBtnContainer.style.display = "none";
      remainingOptions.forEach((option) => {
        option.style.display = "block";
      });
      // Persist only for this page lifecycle (AJAX switches), not reloads
      window.__capacityExpanded = true;
    } else {
      // Collapse - show the + button and hide remaining options
      expandBtnContainer.style.display = "block";
      remainingOptions.forEach((option) => {
        option.style.display = "none";
      });
      // Reset page-lifecycle flag
      window.__capacityExpanded = false;
    }
  }

  // Function to restore capacity expanded state (page-lifecycle only)
  function restoreCapacityExpandedState() {
    const expandBtnContainer = document.querySelector(
      ".capacity-expand-btn-container"
    );
    const remainingOptions = document.querySelectorAll(
      ".capacity-remaining-option"
    );

    if (expandBtnContainer && remainingOptions.length > 0) {
      const isExpanded = window.__capacityExpanded === true; // undefined or false => collapsed

      if (isExpanded) {
        // Show remaining options and hide + button
        expandBtnContainer.style.display = "none";
        remainingOptions.forEach((option) => {
          option.style.display = "block";
        });
      } else {
        // Show + button and hide remaining options
        expandBtnContainer.style.display = "block";
        remainingOptions.forEach((option) => {
          option.style.display = "none";
        });
      }
    }
  }

  function parseVariantValue(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      try {
        const decoder = document.createElement("textarea");
        decoder.innerHTML = raw;
        const decoded = decoder.value;
        return JSON.parse(decoded);
      } catch (innerErr) {
        console.warn("[sticky-bar] failed to parse variant JSON", innerErr);
        return null;
      }
    }
  }

  function formatCurrency(paise) {
    if (typeof paise !== "number") return "";
    return `₹ ${(paise / 100).toLocaleString("en-IN")}`;
  }

  function updateStickyBar(newDoc) {
    try {
      const newStickyInput = newDoc.querySelector(
        "[data-product-selected-variant]"
      );
      const currentStickyInput = document.querySelector(
        "[data-product-selected-variant]"
      );

      let parsedVariant = null;
      let rawVariantValue = null;
      if (newStickyInput) {
        rawVariantValue =
          newStickyInput.value || newStickyInput.getAttribute("value");
        parsedVariant = parseVariantValue(rawVariantValue);
      }

      if (currentStickyInput && parsedVariant) {
        currentStickyInput.value = JSON.stringify(parsedVariant);
        currentStickyInput.setAttribute(
          "value",
          JSON.stringify(parsedVariant).replace(/"/g, "&quot;")
        );
      }

      const currentStickyParent = document.querySelector(
        ".product__sticky__bar__parent"
      );
      const newStickyParent = newDoc.querySelector(".product__sticky__bar__parent");

      if (currentStickyParent && newStickyParent) {
        const nextImg = newStickyParent.querySelector(
          ".product__sticky__bar__image img"
        );
        const currentImg = currentStickyParent.querySelector(
          ".product__sticky__bar__image img"
        );
        if (nextImg && currentImg) {
          currentImg.src = nextImg.getAttribute("src") || currentImg.src;
          const srcset = nextImg.getAttribute("srcset");
          if (srcset) currentImg.srcset = srcset;
          currentImg.alt = nextImg.getAttribute("alt") || currentImg.alt || "";
        }

        if (parsedVariant) {
          const variantTitle = parsedVariant.public_title || "";
          const currentTitle = currentStickyParent.querySelector(
            ".product__content__title"
          );
          const nextTitle = newStickyParent.querySelector(
            ".product__content__title"
          );
          if (currentTitle) {
            currentTitle.textContent = nextTitle?.textContent || variantTitle;
          }

          const currentVariantTitle = currentStickyParent.querySelector(
            ".variant__margin__zero"
          );
          if (currentVariantTitle) {
            currentVariantTitle.textContent =
              variantTitle || nextTitle?.textContent || "";
          }

          const currentMobileTitle = currentStickyParent.querySelector(
            ".mobile__show"
          );
          const nextMobileTitle = newStickyParent.querySelector(".mobile__show");
          if (currentMobileTitle) {
            currentMobileTitle.textContent =
              nextMobileTitle?.textContent || nextTitle?.textContent || "";
          }

          const priceEls = currentStickyParent.querySelectorAll(
            ".actual__price"
          );
          priceEls.forEach((el) => {
            const svg = el.querySelector(".info-svg");
            el.textContent = formatCurrency(parsedVariant.price);
            if (svg) el.appendChild(svg);
          });

          const atcButton = currentStickyParent.querySelector(
            ".product__atc__button"
          );
          if (atcButton) {
            atcButton.setAttribute("data-variant-id", parsedVariant.id);
            if (parsedVariant.available === false) {
              atcButton.textContent = "Sold Out";
              atcButton.classList.add("custom__btn__soldOut");
              atcButton.classList.remove("custom__btn");
            } else {
              atcButton.textContent = "Add To Cart";
              atcButton.classList.add("custom__btn");
              atcButton.classList.remove("custom__btn__soldOut");
            }
          }
        }
      }

      if (parsedVariant) {
        const breakdownMRP = document.querySelector(".breakdown-mrp");
        const breakdownSellingPrice = document.querySelector(
          ".breakdown-selling-price"
        );
        const breakdownDiscount = document.querySelector(".breakdown-discount");
        const discountLabel = document.querySelector(
          ".discount-percentage-label"
        );

        if (breakdownSellingPrice) {
          breakdownSellingPrice.textContent = formatCurrency(
            parsedVariant.price
          );
        }

        if (
          breakdownMRP &&
          breakdownDiscount &&
          parsedVariant.compare_at_price > parsedVariant.price
        ) {
          const discountValue =
            parsedVariant.compare_at_price - parsedVariant.price;
          breakdownMRP.textContent = formatCurrency(
            parsedVariant.compare_at_price
          );
          breakdownDiscount.textContent = `-${formatCurrency(discountValue)}`;
          if (discountLabel) {
            const discountPercentage = Math.round(
              (discountValue / parsedVariant.compare_at_price) * 100
            );
            discountLabel.textContent = `(-${discountPercentage}% OFF)`;
          }
        } else if (discountLabel) {
          discountLabel.textContent = "";
        }

        const variantData = parsedVariant;
        if (variantData && variantData.id) {
          document.dispatchEvent(
            new CustomEvent("on:variant:change", {
              detail: { variant: variantData },
            })
          );
        }
      }
    } catch (err) {
      console.warn("[sticky-bar] update failed", err);
    }
  }

  function swatchHandler(e) {
    e.preventDefault();
    let productURL = this.getAttribute("href");
    console.log(productURL, "Siddesh Product");
    if (!productURL || isSwitchingProduct) return;

    // Hide all loaders and remove any active state
    document.querySelectorAll(".loader, .loader-line").forEach((loader) => {
      loader.style.display = "none";
    });
    document
      .querySelectorAll(".active_loader, .active-round-loader")
      .forEach((el) =>
        el.classList.remove("active_loader", "active-round-loader")
      );

    // Show loader for the clicked card (slide/color/capacity)
    const container = this.closest(
      ".swiper-slide, .col_mat_modular_sofa, .capacity_modular_sofa"
    );
    if (container) {
      const loaderEl = container.querySelector(".loader, .loader-line");
      if (loaderEl) {
        loaderEl.style.display = "block";
        // Add appropriate active class based on loader type
        if (loaderEl.classList.contains("loader")) {
          container.classList.add("active-round-loader");
        } else if (loaderEl.classList.contains("loader-line")) {
          container.classList.add("active_loader");
        }
      }
    }

    ajaxSwitchProduct(productURL);
  }

  // ✅ addon-swiper init function
  function initAddonSwiper() {
    if (document.querySelector(".addon-swiper")) {
      new Swiper(".addon-swiper", {
        slidesPerView: 1.5,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 1,
          },
        },
      });
    }
  }

  // Default style show
  function showDefaultStyle() {
    document.querySelectorAll(".style-block").forEach((block) => {
      block.style.display = "none";
    });
    let firstBlock = document.querySelector(".style-block");
    if (firstBlock) firstBlock.style.display = "block";
  }

  // Bind style tabs
  function bindStyleTabs() {
    let slides = document.querySelectorAll(
      ".style-configutation .swiper-slide"
    );

    slides.forEach((slide) => {
      let link = slide.querySelector(".sofa_style_option");
      if (link) {
        link.removeEventListener("click", styleHandler); // remove old
        link.addEventListener("click", styleHandler);
      }
    });
  }

  function styleHandler(e) {
    // no preventDefault here; allow default or the other handler to run
    let selectedStyle = this.querySelector("p")
      ? this.querySelector("p").innerText.toLowerCase().replace(/\s+/g, "-")
      : "";
    if (selectedStyle.includes("console")) {
      selectedStyle = selectedStyle.replace("console", "consol");
    }
    localStorage.setItem("selectedSofaStyle", selectedStyle);
  }

  function restoreLastStyle() {
    let lastStyle = localStorage.getItem("selectedSofaStyle");
    let slides = document.querySelectorAll(
      ".style-configutation .swiper-slide"
    );
    let targetSlide = null;

    function normalizeStyle(text) {
      let style = text.toLowerCase().replace(/\s+/g, "-");
      if (style.includes("console")) style = style.replace("console", "consol");
      return style;
    }

    // Hide all style blocks initially
    document.querySelectorAll(".style-block").forEach((block) => {
      block.style.display = "none";
    });

    // Remove all active classes first
    slides.forEach((slide) => {
      slide.classList.remove("active");
      if (slide.querySelector(".inner_swiper_div")) {
        slide.querySelector(".inner_swiper_div").classList.remove("active");
      }
    });

    let matchFound = false;

    if (lastStyle) {
      slides.forEach((slide, index) => {
        let link = slide.querySelector(".sofa_style_option p");
        if (link && !slide.classList.contains("disable")) {
          let linkStyle = normalizeStyle(link.innerText);
          if (linkStyle === lastStyle) {
            slide.classList.add("active");
            matchFound = true;
            targetSlide = { slide, index };

            // Show corresponding style block
            let styleBlock = document.querySelector(".style-" + linkStyle);
            if (styleBlock) {
              styleBlock.style.display = "block";

              // Reset the inner swiper if it exists
              let innerSwiper = styleBlock.querySelector(
                ".configurator-swiper.configuration-style"
              );
              if (innerSwiper && innerSwiper.swiperInstance) {
                innerSwiper.swiperInstance.slideTo(0, 0);
              }
            }
          }
        }
      });
    }

    // If no match found or no lastStyle, select first non-disabled slide
    if (!matchFound) {
      for (let i = 0; i < slides.length; i++) {
        if (!slides[i].classList.contains("disable")) {
          slides[i].classList.add("active");
          targetSlide = { slide: slides[i], index: i };

          let link = slides[i].querySelector(".sofa_style_option p");
          if (link) {
            let style = normalizeStyle(link.innerText);
            let styleBlock = document.querySelector(".style-" + style);
            if (styleBlock) {
              styleBlock.style.display = "block";
            }
          }
          break;
        }
      }
    }

    // Update main swiper position
    if (targetSlide) {
      const swiperEl = targetSlide.slide.closest(".configurator-swiper");
      if (swiperEl && swiperEl.swiperInstance) {
        swiperEl.swiperInstance.slideTo(targetSlide.index, 0);
      }
    }
  }

  
    // Swiper initialize
    var styleSwiper = new Swiper(".configurator-swiper.configuration-style", {
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });

    // Saare slides select karo
    let slides = document.querySelectorAll(
      ".configurator-swiper.configuration-style .swiper-slide"
    );

    slides.forEach((slide, index) => {
      slide.addEventListener("click", function () {
        // sabse pehle sabke active hatao
        slides.forEach((s) => s.classList.remove("active"));
        // fir clicked slide ko active do
        slide.classList.add("active");

        // Swiper ko us slide pe le jao
        styleSwiper.slideTo(index);
      });
    });

  
    restoreLastStyle();

// Run on first load
initConfigurators();
initAddOnSwipers();
bindSwatchClicks();
bindStyleTabs();
setupPrefetchForLinks();
restoreLastStyle();
reinitializePincodeChecker();
restoreCapacityExpandedState();
 // Restore capacity expanded state on page load
});
